import { useState, useEffect, useRef, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { Column } from 'primereact/column';
import getPermissao from '../../service/getPermissao';
import { TreeTable } from 'primereact/treetable';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

export default function PermissaoList({ onEdit, onSelect, date, listInactivePermissions }:{ onEdit:(permission:any)=>void, onSelect:(permission:any)=>void, date:Date, listInactivePermissions: boolean }) {
  const { t } = useTranslation();
  const [nodes, setNodes] = useState<any[]>([]);
  const [selectedNodeKey, setSelectedNodeKey] = useState<any>(null);
  const [search, setSearch] = useState('');
  const [expandedKeys, setExpandedKeys] = useState<any>({});
  const searchTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }
    searchTimeout.current = setTimeout(() => setSearch(value), 300);
  };

  const createPermissoes = () => {
    const option: any[] = [];
    getPermissao().then(data => {
      data.sort((s1:{ label: string}, s2:{label: string}) => {
        const nameA = s1.label.toUpperCase(); // ignore upper and lowercase
        const nameB = s2.label.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      })
      data.forEach((element: any) => {
        if (listInactivePermissions || !element.inativa) {
          if (listInactivePermissions || !element.inativa) {
            option.push({ data: element, key: element.id, Collapse: true, children: createPermissoesFilhos(element.permissoes) });
          }

        }
      });
      setNodes(option);
    });
    return option;
  };

  const createPermissoesFilhos = (permissoes: any[]) => {
    const option: any[] = [];
    if (permissoes) {
      permissoes.sort((s1:{ label: string}, s2:{label: string}) => {
        const nameA = s1.label.toUpperCase(); // ignore upper and lowercase
        const nameB = s2.label.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      permissoes.forEach((element: any) => {
        if (listInactivePermissions || !element.inativa) {
          if (listInactivePermissions || !element.inativa) {
            option.push({ data: element, key: element.id, Collapse: true, children: createPermissoesFilhos(element.permissoes) });
          }
        }
      });
    }
    return option;
  };

  const normalize = (text: string) => {
    return (text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  };

  const filterTree = (list: any[], term: string): any[] => {
    const result: any[] = [];
    list.forEach(node => {
      if (normalize(node.data.label).includes(term)) {
        result.push(node);
      }
      else {
        const children = filterTree(node.children || [], term);
        if (children.length > 0) {
          result.push({ ...node, children });
        }
      }
    });
    return result;
  };

  const collectKeys = (list: any[], keys: any = {}) => {
    list.forEach(node => {
      keys[node.key] = true;
      if (node.children) {
        collectKeys(node.children, keys);
      }
    });
    return keys;
  };

  const term = normalize(search.trim());
  const filteredNodes = useMemo(() => (term ? filterTree(nodes, term) : nodes), [nodes, term]);
  const searchExpandedKeys = useMemo(() => (term ? collectKeys(filteredNodes) : null), [filteredNodes, term]);

  const onSelected = (event: any) => {
    onSelect(event.node.data);
  };

  const onUnselect = (event: any) => {
    onSelect(null);
  };

  const labelTemplate = (node: any) => {
    return (
      <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>
        <span style={{ fontWeight: 'bold' }}>{node.data.label}</span>
        {node.data.composicaoConsulta && (
          <div style={{ fontSize: '0.8rem', fontWeight: 'normal', color: '#6c757d' }}>{node.data.composicaoConsulta}</div>
        )}
      </span>
    );
  };

  const actionTemplate = (event: any) => {
    return (
      <div className="flex flex-wrap gap-2" style={{ display: 'flex', justifyContent: 'end' }}>
        <Button icon="pi pi-pencil" onClick={() => onEdit(event.data)} style={{ background: 'transparent', color: 'gray', border: 'none' }} />
      </div>
    );
  };

  useEffect(() => {
    createPermissoes();
  }, [date, listInactivePermissions]);

  const header = (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <span style={{ position: 'relative', display: 'inline-block' }}>
        <i className="pi pi-search" style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: '#6c757d' }} />
        <InputText onChange={onSearchChange} placeholder="Buscar por descrição" style={{ paddingLeft: '2.5rem', width: '20rem' }} />
      </span>
    </div>
  );

  return (
    <div>
      <TreeTable value={filteredNodes} header={header} expandedKeys={term ? searchExpandedKeys : expandedKeys} onToggle={(e) => setExpandedKeys(e.value)} selectionMode="single" selectionKeys={selectedNodeKey} onSelectionChange={(e) => setSelectedNodeKey(e.value)} metaKeySelection={false} onSelect={onSelected} onUnselect={onUnselect} tableStyle={{ minWidth: '50rem' }}>
        <Column field="label" header={t('permissoes')} expander body={labelTemplate}></Column>
        <Column body={actionTemplate} />
      </TreeTable>
    </div>
  );
}
